var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M21.954 6.563a1.534 1.534 0 1 0 0 3.071c.845 0 1.535-.69 1.535-1.536 0-.845-.69-1.535-1.535-1.535m-6.839 1.973a6.47 6.47 0 0 0-6.46 6.46c0 3.56 2.9 6.46 6.46 6.46s6.46-2.9 6.46-6.46-2.9-6.46-6.46-6.46m0 10.599a4.14 4.14 0 0 1-4.14-4.139 4.14 4.14 0 0 1 4.14-4.139 4.14 4.14 0 0 1 4.139 4.14 4.14 4.14 0 0 1-4.14 4.138","key":0}),React.createElement("path",{"fill":"currentColor","d":"M20.24 28.118H9.76c-4.347 0-7.885-3.538-7.885-7.885V9.753c.007-4.34 3.545-7.878 7.892-7.878h10.48c4.347 0 7.885 3.538 7.885 7.885v10.48c0 4.347-3.538 7.885-7.884 7.885zM9.767 4.345A5.42 5.42 0 0 0 4.352 9.76v10.48a5.42 5.42 0 0 0 5.415 5.415h10.48a5.42 5.42 0 0 0 5.415-5.415V9.76a5.42 5.42 0 0 0-5.414-5.415z","key":1})]);
}

Instagram.defaultProps = {"fill":"none","viewBox":"0 0 30 30"};

module.exports = Instagram;

Instagram.default = Instagram;
